import type { ReactNode } from 'react';
import { useFrontendSettings } from '@frontend/utils/hooks/useFrontendSettings';
import type { IProcess } from '../../../../interfaces/process';
import type { IServiceGetOne } from '../../../../interfaces/serviceGetOne';
import type { IItemState } from '../../../episodes/Episode';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { EditProcessContainer, ProcessContainer } from '../../../episodes/common';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';

interface IRequestProcessContainerProps {
    children: ReactNode;
    isAdministrativeActivity?: boolean;
    isExaminationRequest?: boolean;
    isFirstItem: boolean;
    itemState?: IItemState;
    organizationName?: string;
    practitionerName?: string;
    process?: IProcess;
    service: IServiceGetOne;
    title: string;
    tooltip?: string;
    tooltipHeader?: string;
}

export function NewOrEditRequestProcessContainer(props: IRequestProcessContainerProps) {
    const { frontendSettings } = useFrontendSettings();
    if (props.process && props.itemState) {
        return (
            <ProcessContainer
                isActiveActivity={props.itemState.initialIsOpen}
                isAdministrativeActivity={props.isAdministrativeActivity}
            >
                <ProcessItemHeader
                    isAdministrativeActivity={props.isAdministrativeActivity}
                    isExaminationRequest={props.isExaminationRequest}
                    isFirstItem={props.isFirstItem}
                    isFirstProcess={props.itemState.isFirstProcess}
                    isItemOpen
                    organizationName={
                        props.organizationName ||
                        (props.process.requesterOrganization?.name
                            ? props.process.requesterOrganization?.name
                            : undefined)
                    }
                    practitionerName={
                        props.practitionerName ||
                        (props.process.requesterPractitioner
                            ? getDisplayName(props.process.requesterPractitioner)
                            : undefined)
                    }
                    process={props.process}
                    serviceType={props.service.serviceType}
                    title={props.title}
                    tooltip={props.tooltip}
                    tooltipHeader={props.tooltipHeader}
                />
                {props.children}
            </ProcessContainer>
        );
    } else {
        return (
            <EditProcessContainer
                experimentalCarepathOphthalmologyEnabled={frontendSettings.experimentalCarepathOphthalmologyEnabled}
                isActiveActivity={props.itemState?.initialIsOpen}
                isAdministrativeActivity={props.isAdministrativeActivity}
            >
                <ProcessItemHeader
                    isAdministrativeActivity={props.isAdministrativeActivity}
                    isExaminationRequest={props.isExaminationRequest}
                    isFirstItem={props.isFirstItem}
                    isItemOpen
                    process={props.process}
                    serviceType={props.service.serviceType}
                    title={props.title}
                    tooltip={props.tooltip}
                    tooltipHeader={props.tooltipHeader}
                />
                {props.children}
            </EditProcessContainer>
        );
    }
}
